// extracted by mini-css-extract-plugin
module.exports = {"page":"_3kh-BFZk","title":"_36SIfNjR","subtitle":"_2BtrwYxU","text":"zF1UOhes"};